<template>
  <c-modal
    v-model="modal"
    size="lg"
    centered
    no-fade
    :tag="false"
    title="Duplicate Category Confirmation"
    confirm-label="Yes, Duplicate Category"
    cancel-label="No, Never mind"
    :progressing="duplicateLoading"
    @submit="duplicateCategory"
  >
    <template>
      <div class="mb-4 text-center">
        Do you want to make a copy of <b>{{category.CategoryDESC}}</b> in the following menu?
      </div>
      <div class="mb-4 text-center">
        Choose a destination menu for the copy
      </div>

      <div v-if="destinationLoading" class="text-center py-2">
        <b-spinner small class="mr-2"/> Loading menu types...
      </div>
      <b-form-group v-else>
        <b-input-group prepend="Menu Type">
          <b-select
            v-model="selectedMenuTypeID"
            value-field="MenuTypeID"
            text-field="MenuType"
            :options="destinationMenuTypes"
          />
        </b-input-group>
      </b-form-group>
    </template>
  </c-modal>
</template>

<script>
  import CModal from "../../../shared/Cmodal";
  export default {
    name: "DuplicateCategory",
    components: {CModal},
    props: {
      value: {required: true},
      category: {
        required: true,
        type: Object,
        default: () => ({})
      },
      edibleType: {required: true, type: String},
      currentMenuType: {required: false, default: () => ({})}
    },
    data () {
      return {
        destinationLoading: false,
        destinationMenuTypes: [],
        selectedMenuTypeID: null,
        duplicateLoading: false
      }
    },
    computed: {
      modal: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      value (val) {
        if (val) {
          this.selectedMenuTypeID = null
          this.getDestinationMenuTypes()
        }
      }
    },
    methods: {
      getDestinationMenuTypes () {
        const model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          EdibleType: this.edibleType
        }
        this.destinationLoading = true
        return this.$api.menuType.list(model).then(res => {
          this.destinationMenuTypes = (res.data && res.data.menuTypes) || []
          this.destinationLoading = false
          const currentMenuType = this.currentMenuType && this.destinationMenuTypes.find(
            menuType => menuType.MenuTypeID === this.currentMenuType.MenuTypeID
          )
          if (currentMenuType) {
            this.selectedMenuTypeID = currentMenuType.MenuTypeID
          } else if (this.destinationMenuTypes.length) {
            this.selectedMenuTypeID = this.destinationMenuTypes[0].MenuTypeID
          }
        }).catch(() => {
          this.destinationLoading = false
          this.destinationMenuTypes = []
          this.$showError('Error loading menu types')
        })
      },
      duplicateCategory () {
        const model = {
          UserID: localStorage.getItem('userID'),
          RestaurantID: this.$store.state.selectedRestaurantId,
          CategoryID: this.category.CategoryID,
          ItemType: this.edibleType,
          DestMenuTypeID: this.selectedMenuTypeID
        }
        this.duplicateLoading = true
        return this.$api.getRestaurant.DuplicateCategory(model).then(res => {
          this.duplicateLoading = false
          if (res.success) {
            this.modal = false
            this.$emit('refresh', {MenuTypeID: this.selectedMenuTypeID})
          } else {
            this.$showError(res.message)
          }
        }).catch(() => {
          this.duplicateLoading = false
          this.$showError('error on duplicating category')
        })
      }
    }
  }
</script>

<style scoped>

</style>
